export class AppXtender {
  appId!: number;
  name!: string;
  docType!: string;
  docSubType!: string;
  fileDesc!: string;
  activityDate!: string;
  documentType!: string;
  fileName!: string;
  authRequired!: boolean;
  tags!: string;
}
